const items = [
  'Football',
  'Cricket',
  'Badminton',
  'Basketball',
  'Pickleball',
  'Volleyball',
  '500+ Turfs',
  '120 Cities',
]

export function Ticker() {
  const doubled = [...items, ...items]
  return (
    <div
      className="overflow-hidden py-3"
      style={{
        background: 'rgba(184,236,60,.03)',
        borderBottom: '1px solid var(--lime-line)',
        borderTop: '1px solid var(--lime-line)',
      }}
    >
      <div className="flex gap-10 whitespace-nowrap animate-[ticker_24s_linear_infinite]">
        {doubled.map((item, i) => (
          <span className="flex items-center gap-10" key={i}>
            <span
              className="text-[0.75rem] font-semibold tracking-widest uppercase"
              style={{ color: i % 2 === 0 ? 'var(--text-dim)' : 'var(--lime)' }}
            >
              {item}
            </span>
            <span style={{ color: 'var(--lime)', fontSize: '0.5rem' }}>✦</span>
          </span>
        ))}
      </div>
    </div>
  )
}
